import CheckboxControl from './CheckboxControl'
export default CheckboxControl


// WEBPACK FOOTER //
// ./src/modules/CheckboxControl/index.js